import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enCommon from './locales/en/common.json';
import arCommon from './locales/ar/common.json';
import enSetup from './locales/en/setup.json';
import arSetup from './locales/ar/setup.json';
import enRetainer from './locales/en/retainer.json';
import arRetainer from './locales/ar/retainer.json';
import enCourt from './locales/en/court.json';
import arCourt from './locales/ar/court.json';
import enAdmin from './locales/en/admin.json';
import arAdmin from './locales/ar/admin.json';
import enDelegation from './locales/en/delegation.json';
import arDelegation from './locales/ar/delegation.json';
import enEmailInbox from './locales/en/email_inbox.json';
import arEmailInbox from './locales/ar/email_inbox.json';
import enCrm from './locales/en/crm.json';
import arCrm from './locales/ar/crm.json';
import enDocuments from './locales/en/documents.json';
import arDocuments from './locales/ar/documents.json';
import enBilling from './locales/en/billing.json';
import arBilling from './locales/ar/billing.json';
import enNotifications from './locales/en/notifications.json';
import arNotifications from './locales/ar/notifications.json';
import enDashboard from './locales/en/dashboard.json';
import arDashboard from './locales/ar/dashboard.json';
import enClientPortal from './locales/en/client_portal.json';
import arClientPortal from './locales/ar/client_portal.json';
import enPrivacy from './locales/en/privacy.json';
import arPrivacy from './locales/ar/privacy.json';
import enOcr from './locales/en/ocr.json';
import arOcr from './locales/ar/ocr.json';
import enConflict from './locales/en/conflict.json';
import arConflict from './locales/ar/conflict.json';
import enLegalServices from './locales/en/legal-services.json';
import arLegalServices from './locales/ar/legal-services.json';
import enClient360 from './locales/en/client360.json';
import arClient360 from './locales/ar/client360.json';
import enTaxonomy from './locales/en/taxonomy.json';
import arTaxonomy from './locales/ar/taxonomy.json';
import enSearch from './locales/en/search.json';
import arSearch from './locales/ar/search.json';
import enSuggestions from './locales/en/suggestions.json';
import arSuggestions from './locales/ar/suggestions.json';

export const SUPPORTED_LOCALES = ['en', 'ar'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const RTL_LOCALES: readonly Locale[] = ['ar'];
export const isRtl = (locale: string): boolean => RTL_LOCALES.includes(locale as Locale);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enCommon, setup: enSetup, retainer: enRetainer, court: enCourt, admin: enAdmin, delegation: enDelegation, email_inbox: enEmailInbox, crm: enCrm, documents: enDocuments, billing: enBilling, notifications: enNotifications, dashboard: enDashboard, client_portal: enClientPortal, privacy: enPrivacy, ocr: enOcr, conflict: enConflict, 'legal-services': enLegalServices, client360: enClient360, taxonomy: enTaxonomy, search: enSearch, suggestions: enSuggestions },
      ar: { common: arCommon, setup: arSetup, retainer: arRetainer, court: arCourt, admin: arAdmin, delegation: arDelegation, email_inbox: arEmailInbox, crm: arCrm, documents: arDocuments, billing: arBilling, notifications: arNotifications, dashboard: arDashboard, client_portal: arClientPortal, privacy: arPrivacy, ocr: arOcr, conflict: arConflict, 'legal-services': arLegalServices, client360: arClient360, taxonomy: arTaxonomy, search: arSearch, suggestions: arSuggestions },
    },
    fallbackLng: 'ar',
    supportedLngs: SUPPORTED_LOCALES,
    defaultNS: 'common',
    ns: ['common', 'setup', 'retainer', 'court', 'admin', 'delegation', 'email_inbox', 'crm', 'documents', 'billing', 'notifications', 'dashboard', 'client_portal', 'privacy', 'ocr', 'conflict', 'legal-services', 'client360', 'taxonomy', 'search', 'suggestions'],
    compatibilityJSON: 'v4',
    interpolation: { escapeValue: false },
    // BRD §11.3: AR-default for all MENA users. Detect ONLY from our own
    // localStorage key — never from navigator language — so a cleared/fresh
    // visit falls through to fallbackLng ('ar') instead of the browser's EN.
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'jylaw.lang',
    },
  });

export default i18n;
